import * as _ from 'lodash-es';
import { INSTALLABLE_PLATFORM_INFO_MAP } from '../../integrations/IntegrationPlatformInfo';

const getExternalServiceName = (platform: string) => {
  const integration = INSTALLABLE_PLATFORM_INFO_MAP[platform];
  return integration?.name || _.capitalize(platform);
};

export default getExternalServiceName;
